import { render, staticRenderFns } from "./cModalUpdateSale.vue?vue&type=template&id=58a96b7a&scoped=true"
import script from "./cModalUpdateSale.vue?vue&type=script&lang=js"
export * from "./cModalUpdateSale.vue?vue&type=script&lang=js"
import style0 from "./cModalUpdateSale.vue?vue&type=style&index=0&id=58a96b7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a96b7a",
  null
  
)

export default component.exports